// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2vY1z","file":"styles_file__WFUFP"};